<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      resizable
      border
      size="small"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :row-id="'amzFlipOrderSkuCode'"
      :span-method="rowspanMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:amzMarketName="{ row }">
        <div style="display: flex;justify-items: center;align-items: center;">
          <div style="flex: 1;">
            {{ row.amzMarketName }}
          </div>
          <div class="tag">
            <span
              class="animate-ping tag-sapn absolute"
              :style="{ backgroundColor: row.alertLevelColor }"
            ></span>
            <span
              class="tag-sapn relative"
              :style="{ backgroundColor: row.alertLevelColor }"
            ></span>
          </div>
        </div>
      </template>
      <template v-slot:skuInfo="{ row }">
        <span>SKU：</span><span style="color: #303133">{{ row.amzSkuNo }}</span>
        <br />
        <span>SPU：</span><span style="color: #303133">{{ row.amzSpuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzFlipOrderSkuStatus == 'N'
              ? 'info'
              : row.amzFlipOrderSkuStatus == 'C'
              ? 'warning'
              : row.amzFlipOrderSkuStatus == 'S'
              ? ''
              : row.amzFlipOrderSkuStatus == 'P'
              ? 'success'
              : row.amzFlipOrderSkuStatus == 'R'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_amzFlipOrderSkuStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="420px"
      v-if="dialogVisible"
      :before-close="closeRejected"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        label-position="top"
      >
        <el-form-item
          :label="$l('tips_review') || '是否要审核驳回？'"
          prop="rejectReason"
        >
          <el-input
            type="textarea"
            maxlength="50"
            show-word-limit
            :rows="8"
            :placeholder="$l('tips_rejected_reason') || '请输入驳回原因'"
            v-model="form.rejectReason"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeRejected">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="rejected">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
import { format } from '@/libs/util.number.js'
import validate from '@/libs/util.validate'

export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      endMerger: false,
      dialogVisible: false,
      form: {
        amzFlipOrderSkuCode: '',
        rejectReason: '',
      },
      rules: {
        rejectReason: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'passed':
          this.passed(data.amzFlipOrderSkuCode)
          break
        case 'rejected':
          this.openRejected(data.amzFlipOrderSkuCode)
          break
      }
    },
    async rejected() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.dialogVisible = false)
      if (this.loadingOpen()) return
      this.$api
        .ecomAmzFlipOrderSkuRejectedApi({
          amzFlipOrderSkuCodes: [this.form.amzFlipOrderSkuCode],
          rejectReason: this.form.rejectReason,
        })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status == 200) {
            this.$message({
              showClose: true,
              message: this.$l('tips_rejected_success') || '驳回成功',
              type: 'success',
            })
          }
          this.closeRejected()
          this.$emit('reload')
        })
        .catch(async () => {
          this.loadingClose()
        })
    },
    openRejected(amzFlipOrderSkuCode) {
      this.dialogVisible = true
      this.form.amzFlipOrderSkuCode = amzFlipOrderSkuCode
    },
    closeRejected() {
      this.dialogVisible = false
      this.form.rejectReason = ''
      this.form.amzFlipOrderSkuCode = ''
    },
    passed(amzFlipOrderSkuCode) {
      const that = this
      this.$confirm(
        this.$l('tips_passed') || '是否要审核通过？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        if (that.loadingOpen()) return
        that.$api
          .ecomAmzFlipOrderSkuPassedApi({
            amzFlipOrderSkuCodes: [amzFlipOrderSkuCode],
          })
          .then((res) => {
            that.loadingClose()
            const { status } = res
            if (status == 200) {
              that.$message({
                showClose: true,
                message: that.$l('tips_passed_success') || '通过成功',
                type: 'success',
              })
            }
            that.$emit('reload')
          })
          .catch(() => {
            that.loadingClose()
          })
      })
    },
    rowspanMethod({ row, column }) {
      const notMerger = [
        'amzMarketName',
        'dailySales',
        'fbaInv',
        'ftyInvDaysAvailable',
        'fbaSafetyStockDays',
      ]
      if (notMerger.includes(column.property)) {
        return { rowspan: 1, colspan: 1 }
      } else {
        return { rowspan: row.rowspan, colspan: 1 }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes ping {
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1.5s cubic-bezier(0, 0, 0.1, 0.6) infinite;
}
.tag {
  position: relative;
  display: inline-flex;
  justify-content: center;
}
.tag-sapn {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  opacity: 0.75;
  display: inline-flex;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
</style>
